import { render } from "./TemplatesList.vue?vue&type=template&id=94c37ad2"
import script from "./TemplatesList.vue?vue&type=script&lang=js"
export * from "./TemplatesList.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__